import { HomeFloorBIcon } from './HomeFloorBIcon';

/**
 * author: GreenTurtwig
 * id 004E747A-FD00-4B6E-8AEF-2031D217D035
 * name home-floor-b
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-b.svg
 * tags
 * - Home Automation 
 */
export const HouseFloorBasementIcon = HomeFloorBIcon;
export default HouseFloorBasementIcon